import React from 'react';
import { m } from 'framer-motion';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function FinalCTA() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-61" data-mp="3mu1qc0878s9o">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-62" data-mp="3mt8s5nnb3b35">
        <h2 className="font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-63" data-mp="3rs388htw2ljk">
          Tus clases necesitan una planificación. Tu tiempo también importa.
        </h2>

        <div className="mx-auto mt-6 max-w-xl space-y-3 text-left text-base leading-relaxed text-ink sm:text-center" data-id="element-64" data-mp="3hv6zcb02vxeh">
          <p data-id="element-65" data-mp="33vxvmat26vre">Deja de buscar ejercicios en diferentes lugares cada vez que necesitas preparar una sesión.</p>
          <p data-id="element-66" data-mp="38usbp4zn667t">
            Con Enciclopedia Pilates 360 tienes un repertorio organizado con indicaciones, correcciones y
            alternativas para trabajar con tus alumnos.
          </p>
          <p className="font-semibold text-primary" data-id="element-67" data-mp="171kx5xrursmz">
            Dedica menos tiempo a buscar ejercicios y más atención a enseñar, observar y corregir.
          </p>
        </div>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-8 flex flex-col items-center" data-id="element-68" data-mp="la278np7qoaj">
          <PrimaryButton href={CHECKOUT_URL} data-id="element-69" data-mp="uzvfpfu26nak">Quiero acceder a Pilates 360</PrimaryButton>
          <p className="mt-3 text-xs text-ink/60" data-id="element-70" data-mp="7akgw3w9r2z2">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía 7 días
          </p>
          <p className="mt-1 text-xs text-ink/50" data-id="element-71" data-mp="gafusgh7lc2s">
            💱 Precio en euros (EUR). El checkout convierte el cobro automáticamente a la moneda de tu
            país.
          </p>
        </m.div>
      </div>
    </section>;
}